<template>
  <div class="progress">
    <div class="topbg">
      <div class="head">
        <div class="reBackBtn" @click="goBack">
          <img src="../../common/images/oldnew/reback_btn.png" alt="" />
          <!-- <van-icon class="back_btn" name="arrow-left" /> -->
        </div>
        <div class="title">
          老带新推荐
        </div>
        <!-- 老业主带访 -->
        <div class="df"></div>
      </div>
      <div class="search-btn">
        <img
          @click="toSearchHandle"
          src="../../common/images/oldnew/search_btn.png"
        />
      </div>

      <!-- tab_card -->
      <div class="tab_card">
        <div class="choice_module" @scroll="scrollEvent" ref="scrollModule">
          <div
            @click="changeActive(0)"
            :class="{ checked: 0 == checkedBg ? true : false }"
          >
            <span>未处理</span>
            <span>{{ progress }}</span>
          </div>
          <div
            @click="changeActive(1)"
            :class="{ checked: 1 == checkedBg ? true : false }"
          >
            <span>未到访</span>
          </div>
          <div
            :class="{ checked: 2 == checkedBg ? true : false }"
            @click="changeActive(2)"
          >
            <span>已到访</span>
          </div>
          <div
            @click="changeActive(5)"
            :class="{ checked: 5 == checkedBg ? true : false }"
          >
            <span>已认购</span>
          </div>
          <div
            @click="changeActive(6)"
            :class="{ checked: 6 == checkedBg ? true : false }"
          >
            <span>已签约</span>
          </div>
          <div
            @click="changeActive(4)"
            :class="{ checked: 4 == checkedBg ? true : false }"
          >
            <span>已失效</span>
          </div>
        </div>
      </div>
    </div>
    <!-- main -->
    <div class="wrap_main" v-if="tab == 1 || tab == 0">
      <div class="main" v-if="list.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="20"
          @load="onLoadMore"
          :immediate-check="false"
        >
          <div v-for="(item, index) in list" :key="item.id">
            <person-card
              v-if="active !== '4'"
              :content="item.recommend"
              :index="index + 1"
              :type="active"
              :noDisposeTime="item.noDisposeTime"
              @onClick="toggle"
            />
            <person-card
              v-else
              :content="item.recommend"
              :index="index + 1"
              :type="active"
              :noDisposeTime="item.noDisposeTime"
            />
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <no-data tip="暂无数据" />
      </div>
    </div>
    <!-- 已到访 -->
    <div class="wrap_main" v-if="tab == 2">
      <div v-if="list1.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="20"
          @load="onLoadMore"
          :immediate-check="false"
        >
          <div class="visited-wrap" v-for="(item, index) in list1" :key="index">
            <visited :item="item.recommend" :index="index" />
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <no-data tip="暂无数据" />
      </div>
    </div>

    <!-- 已认购 -->
    <div class="wrap_main" v-if="tab == 5">
      <div v-if="list2.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="20"
          @load="onLoadMore"
          :immediate-check="false"
        >
          <div
            class="list"
            v-for="(item, index) in list2"
            :key="index"
            @click="
              toggle({
                id: item.recommend.id,
                type: 1,
                status: item.recommend.status,
              })
            "
          >
            <div class="infor">
              <span>{{ index + 1 }}</span>
              <span class="person_name">{{ item.recommend.presentee }}</span>
              <span>
                <img
                  src="../../common/images/recommend/sex_nan_select.png"
                  v-if="!item.recommend.gender"
                />
                <img
                  src="../../common/images/recommend/sex_nv_select.png"
                  v-else
                />
              </span>
              <span>{{ item.recommend.contactNumber }}</span>

              <span>{{
                moment(item.recommend.subscribeTime).format("YYYY/MM/DD")
              }}</span>
            </div>
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <no-data tip="暂无数据" />
      </div>
    </div>
    <!-- 已签约 -->
    <div class="wrap_main" v-if="tab == 6">
      <div v-if="list2.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="20"
          @load="onLoadMore"
          :immediate-check="false"
        >
          <div
            class="list"
            v-for="(item, index) in list2"
            :key="index"
            @click="
              toggle({
                id: item.recommend.id,
                type: 1,
                status: item.recommend.status,
              })
            "
          >
            <div class="infor">
              <span>{{ index + 1 }}</span>
              <span class="person_name">{{ item.recommend.presentee }}</span>
              <span>
                <img
                  src="../../common/images/recommend/sex_nan_select.png"
                  v-if="!item.recommend.gender"
                />
                <img
                  src="../../common/images/recommend/sex_nv_select.png"
                  v-else
                />
              </span>
              <span>{{ item.recommend.contactNumber }}</span>

              <span>{{
                moment(item.recommend.signDate).format("YYYY/MM/DD")
              }}</span>
            </div>
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <no-data tip="暂无数据" />
      </div>
    </div>

    <!-- 已失效 -->
    <div class="wrap_main" v-if="tab == 4">
      <div v-if="list3.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="20"
          @load="onLoadMore"
          :immediate-check="false"
        >
          <div class="visited-wrap" v-for="(item, index) in list3" :key="index">
            <visited :item="item.recommend" :index="index" :type="false" />
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <no-data tip="暂无数据" />
      </div>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import { List, Icon } from "vant";
import { mapMutations } from "vuex";
import personCard from "@/components/personCard";
import nodata from "@/components/nodata";
import Visited from "@/pages/OldNew2/OldNewComponent/search/components/c-list/adivser/visited";
import moment from "moment";
import loading from "@/components/loading";
export default {
  data() {
    return {
      active: "0",
      tab: 0,
      loading: false,
      finished: false,
      load_more: false, // 是否加载更多
      nowpage: 1, // 当前页数
      progress: 0, // 待跟进
      progressed: 0, // 已跟进
      list: [], // 进度列表
      list1: [],
      list2: [],
      list3: [],
      actives: "1",
      checkedBg: 0,
      adviserCode: 0,
      invalidTotal: 0,
      nowpg: 0,
      scroll: 0,
      moment,
      loadingStatus: false,
    };
  },
  components: {
    "person-card": personCard,
    "no-data": nodata,
    "van-list": List,

    "van-icon": Icon,
    Visited,
    loading,
  },
  created() {
    document.title = "老带新推荐";
    this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":false}');

    //获取用户信息
    this.$jsBridge.callHandler("getProfileInfo", "", (res) => {
      this.adviserCode = res.username;
    });
    this.getData();
    this.tab = this.$store.state.progress_active;
    this.checkedBg = this.$store.state.progress_active;
    this.actives = this.$store.state.progress_actives;
  },
  mounted() {
    this.$refs.scrollModule.scrollLeft = this.$store.state.progress_scroll;
  },
  // 回到该缓存页
  activated() {
    // 禁用原生回退
    this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":false}');
    document.title = "老带新推荐";
  },
  beforeRouteLeave(to, from, next) {
    this.UPDATE_PROGRESS_ACTIVE({
      active: this.tab,
      actives: this.actives,
      scroll: this.scroll,
    });
    // 显示原生回退按钮
    this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');

    this.$nextTick(() => {
      document.title = "老带新推荐";
      this.$jsBridge.callHandler("dispatchBackBtn");
      this.$jsBridge.registerhandler("onBackPressed", () => {
        console.log("$nextTick中替换原生返回点击progressDetaile2");
        this.$router.back();
      });
    });

    next();
  },
  methods: {
    //跳转到搜索页面
    toSearchHandle() {
      this.$router.push({
        path: "/oldnew-search",
        query: {
          type: 2,
        },
      });
    },
    //选项滚动
    scrollEvent() {
      this.scroll = this.$refs.scrollModule.scrollLeft;
    },

    ...mapMutations(["UPDATE_PROGRESS_ACTIVE"]),
    toggle(e) {
      this.$router.push({
        name: "progressDetail",
        query: { id: e.id, type: e.type, status: e.status },
      });
    },
    //业主带访
    takeTo() {
      this.$router.push({
        name: "takeTo",
      });
    },
    //切换菜单
    changeActive(e) {
      if (e === this.tab) {
        return;
      }
      this.active = e;
      this.tab = e;
      this.checkedBg = e;
      this.nowpage = 1;
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.list1 = [];
      this.list2 = [];
      this.list3 = [];
      if (e == 0) {
        this.getData();
      } else if (e == 1) {
        this.adviserFollowList();
      } else if (e == 2) {
        this.visitedData();
      } else if (e == 4) {
        this.invalidData();
      } else if (e == 5) {
        this.orderData();
      } else if (e == 6) {
        this.signData();
      }
    },
    /**
     *
     * 返回事件
     *
     * */
    goBack() {
      // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":true}');
      setTimeout(() => {
        console.log("延时关闭");
        this.$jsBridge.callHandler("finish", "");
        this.$jsBridge.commonCall("finish", "");
      }, 0);
    },
    // 下拉加载更多
    onLoadMore() {
      if (!this.finished) {
        // 是否还有下一页
        this.nowpage = Number(this.nowpage) + 1;
        this.loading = true;
        if (this.tab == 0) {
          this.getData();
        } else if (this.tab == 1) {
          this.adviserFollowList();
        } else if (this.tab == 2) {
          this.visitedData();
        } else if (this.tab == 4) {
          this.invalidData();
        } else if (this.tab == 5) {
          this.orderData();
        } else if (this.tab == 6) {
          this.signData();
        }
      }
      // this.load_more = true;
    },
    // 未处理
    getData(nowpage, size) {
      let params = {
        followed_status: this.active,
        current: this.nowpage,
        size: size ? size : 10,
        statuses: 2,
        requestEntry: 2,
      };

      this.$api
        .adviserFollowList(params)
        .then((res) => {
          if (res.code === "0000") {
            if (res.body) {
              res.body.records.forEach((item) => {
                this.list.push(item);
              });
              this.progress = res.body.total; // 待跟进
              this.progressed = res.body.total; // 已跟进
              if (this.nowpage >= res.body.pages) {
                this.finished = true;
                this.loading = false;
              } else {
                this.loading = false;
                this.finished = false;
              }
            }
            this.loadingStatus = false;
          }
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    // 未到访
    adviserFollowList(nowpage, size) {
      let params = {
        followed_status: this.active,
        current: this.nowpage,
        size: size ? size : 10,

        statuses: 3,
        requestEntry: 2,
      };
      this.$api
        .adviserFollowList(params)
        .then((res) => {
          if (res.code === "0000") {
            if (res.body) {
              res.body.records.forEach((item) => {
                this.list.push(item);
              });
            }

            // this.progress = res.body.total; // 待跟进
            this.progressed = res.body.total; // 已跟进
            if (this.nowpage >= res.body.pages) {
              this.finished = true;
              this.loading = false;
            } else {
              this.loading = false;
              this.finished = false;
            }
            this.loadingStatus = false;
          }
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    //到访
    visitedData(nowpage, size) {
      let params = {
        current: this.nowpage,
        size: size ? size : 10,

        statuses: 4,
        requestEntry: 2,
      };
      this.$api
        .adviserFollowList(params)
        .then((res) => {
          if (res.body) {
            res.body.records.forEach((item) => {
              this.list1.push(item);
            });
          }

          if (this.nowpage >= res.body.pages) {
            this.finished = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = false;
          }
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    //已失效
    invalidData(nowpage, size) {
      let params = {
        current: this.nowpage,
        size: size ? size : 10,

        statuses: 7,
        requestEntry: 2,
      };
      this.$api
        .adviserFollowList(params)
        .then((res) => {
          if (res.body) {
            res.body.records.forEach((item) => {
              this.list3.push(item);
            });
          }

          this.invalidTotal = res.body.total;

          if (this.nowpage >= res.body.pages) {
            this.finished = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = false;
          }
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },

    //已认购
    orderData(nowpg, size) {
      let params = {
        current: this.nowpage,
        size: size ? size : 10,
        statuses: 5,
        requestEntry: 2,
      };
      this.$api
        .adviserFollowList(params)
        .then((res) => {
          res.body.records.forEach((item) => {
            this.list2.push(item);
          });
          if (this.nowpage >= res.body.pages) {
            this.finished = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = false;
          }
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    //已签约
    signData(nowpg, size) {
      let params = {
        current: this.nowpage,
        size: size ? size : 10,

        statuses: 6,
        requestEntry: 2,
      };
      this.$api
        .adviserFollowList(params)
        .then((res) => {
          res.body.records.forEach((item) => {
            this.list2.push(item);
          });
          if (this.nowpage >= res.body.pages) {
            this.finished = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = false;
          }
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  flex-direction: column;
  position: relative;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 99px;
    padding-right: 20px;
    font-size: 36px;
    width: 100%;

    .df {
      width: 168px;
      height: 48px;
      border-radius: 25px;
      // border: 1px solid #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      font-size: 28px;
      font-weight: 500;
    }
    .reBackBtn {
      width: 100px;
      height: 99px;
      display: flex;
      align-items: center;
      img {
        height: 28px;
        width: 18px;
        margin-left: 26px;
      }
    }
    .back_btn {
      width: 100px;
      height: 99px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      padding: 10px;
    }
    .title {
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      padding-left: 60px;
    }
  }
  .search-btn {
    padding: 0px 30px 0px 30px;
    height: 72px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .wrap_main {
    flex: 1;
    overflow: scroll;
    height: 100%;
    .visited-wrap {
      padding: 0 30px;
    }
    .main {
      padding: 30px;
      box-sizing: border-box;
    }
    .nodata {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .list {
    padding: 0 30px;
    margin-bottom: 30px;
    min-height: 120px;
    position: relative;
    &:nth-child(1) {
      margin-top: 20px;
    }
    .infor {
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(164, 164, 164, 0.4);
      border-radius: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      line-height: 80px;
      height: 120px;
      font-weight: 500;

      padding: 0 30px;
      img {
        width: 60px !important;
        height: 66px !important;
        padding: 10px !important;
      }
    }
    .warn {
      font-size: 28px;

      font-weight: 500;
      color: #0d9869;
    }
    .overdue {
      position: absolute;
      top: 0;
      left: 60;
      width: 88px;
      height: 80px;
      z-index: 1;
    }
    .if_expired {
      background: #f7f7f7;
    }
    .person_name {
      max-width: 120px;

      overflow: hidden;

      text-overflow: ellipsis;

      white-space: nowrap;
    }
  }
}
</style>
<style lang="scss">
.progress {
  .topbg {
    background: url("../../common/images/bc.png") no-repeat;
    background-size: 100% 200px;

    .head {
      color: #ffffff;
    }
    .tab_card {
      .choice_module {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        overflow-x: auto;
        div {
          flex: none;

          width: 210px;
          height: 120px;
          background: #ffffff;
          box-shadow: 0px 2px 6px 0px rgba(164, 164, 164, 0.4);
          border-radius: 16px;
          display: inline-flex;
          justify-content: space-around;
          flex-direction: column;
          align-items: center;
          padding: 10px 0;
          margin: 0 10px;
          position: relative;
          span {
            font-size: 28px;
            color: #333333;
            font-weight: 500;
            &:nth-child(2) {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 20px;
              width: 40px;
              height: 27px;
              background: #ff1b43;
              border-radius: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: 500;
              color: #ffffff;
              padding: 4px 0 0 0;
            }
          }
        }
      }
    }
    .checked {
      background: url("../../common/images/checked.png") !important;
      background-size: 100% !important;

      span {
        color: #fff !important;
      }
    }
  }
  .van-tab--active {
    color: #0d9869;
  }
  .van-tab {
    flex-basis: 25% !important;
  }
}
</style>
